import get from 'lodash/get';

export function getIsMobileCustomizable(eventType: string) {
  return eventType === 'greeting_card' || eventType === 'rsvp_event';
}

export function getCardIdFromRoute(route) {
  return parseInt(
    route.pathname === '/card'
      ? route.slug
      : parseInt(get(route, 'query.card', -1)),
  );
}
